import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getMail, saveMail } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import uploadImageCallBack from './upload';

class cmsEditMail extends Component {

    constructor(props) {
        super(props);
        this.state = {
          errors: [],
          mailDetail: '',
          mail_template:'',
          mail_content:'',
          mail_content:'',
          mail_subject:'',
          module:'',
          editorState: EditorState.createEmpty()
        };
        
        this.id = this.props.match.params.id ? this.props.match.params.id : '';
        //this.getMail = this.getMail.bind(this);
    }


    componentDidMount() {

      var THIS = this;
      
      this.getMail(this.id);

    }


    saveMail = ()=>{
          
       // let contentState = this.state.editorState.getCurrentContent();
        console.log("when saving..", this.state.consigne);


        let req = JSON.stringify({
            mail_template:this.state.mail_template,
            mail_subject:this.state.mail_subject,  
            mail_content: this.state.mail_content,
            module:this.state.module,
            id:this.id
        })

        
        saveMail(req).then((response) => {
          
          if(response.status==1){

                alert(response.message);
                

          }else{
                alert(response.message);
          }
      
        });
       

    }

    getMail = () => {
      let ins = JSON.stringify({
        id:this.id
      });

      getMail(ins).then((res) => {
        if (res.status == 1) {
       
        const blocksFromHtml = htmlToDraft(res.detail.mail_content);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);

          this.setState({
            mail_template: res.detail.mail_template,
            mail_subject: res.detail.mail_subject,
            module: res.detail.module,
            mail_content:res.detail.mail_content,
            editorState:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.mail_content)))
          });

           this.setState({ 
            consigne:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.mail_content))) 
           })

        }

      });
    }    


      handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
      };

      onChange = (editorState) => {
        //const contentState = editorState.getCurrentContent();
        //console.log("plain text", editorState.getCurrentContent().getPlainText());

        const contentState = draftToHtml(convertToRaw(editorState.getCurrentContent()))

        console.log("html", contentState);
        //const raw = convertToRaw(contentState);
        this.setState({
          consigne:editorState,
          mail_content:contentState
        });
      }

    render() {

        const { mail_content, editorState, consigne} = this.state;


 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Mail - Edit</h4>
                  <form class="form-sample">
                    
                    <div class="row">

                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Template Name</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" name="mail_template" value={this.state.mail_template} onChange={this.handleChange} />
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Mail Subject</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" name="mail_subject" value={this.state.mail_subject} onChange={this.handleChange} />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Module</label>
                          <div class="col-sm-9">
                            <select class="form-control" name="module"  value={this.state.module} onChange={this.handleChange}>
                              <option value="parents">Parent</option>
                              <option value="partners">Partner</option>
                              <option value="otpmessage">OTP Message</option>
                              <option value="partnersubscription">Partner Subscription</option>
                              <option value="payments">Payments</option>
                              <option value="followups">FollowUps</option>
                              <option value="general">General</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                     
                      <div class="col-md-12">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Mail Content</label>
                          <div class="col-sm-12">
                                <Editor
                                  //defaultEditorState={editorState}
                                  value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                                  editorState={consigne}
                                  toolbarClassName="toolbarClassName"
                                  wrapperClassName="wrapperClassName"
                                  editorClassName="editorClassName"
                                  onEditorStateChange={this.onChange.bind(this)}
                                  //onEditorStateChange={(consigne) => {this.setState({consigne})}}
                                />
                          </div>
                           
                        </div>
                      </div>
                    </div>
                     
                    <div class="row">
                      <div class="col-md-12">
                        <div className="row mb-4 text-right">
                          <button type='button' id="btnSubmit"
                            className="btn btn-primary btn-sm" onClick={this.saveMail} style={{ display: "block", margin: "auto" }}>
                            Submit
                          </button>
                        </div>
                       
                      </div>
                    </div> 
                    
                  </form>
                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }
}



export default cmsEditMail;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsEditMail.jsx